module.exports = __webpack_public_path__ + "static/media/cloud2.73662e44.svg";